/* SBT / Apex navigation dropdown fix
   Parent items render <a href="#"> and the theme opens submenus via CSS
   :hover / :focus-within. A click/tap focuses the href="#" link; it never
   navigates, so focus sticks and :focus-within holds the menu open. This
   releases that focus on outside-click, Escape, and header mouseleave. */
(function () {
  var TRIGGER = '.navigation-item.has-sub-menu';

  function focusedNavLink() {
    var a = document.activeElement;
    return (a && a.closest && a.closest(TRIGGER)) ? a : null;
  }
  function closeMenu() {
    var a = focusedNavLink();
    if (a) a.blur();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest(TRIGGER + ' > a');
    if (t && t.getAttribute('href') === '#') e.preventDefault();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest(TRIGGER)) closeMenu();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeMenu();
  });

  var navBar = document.querySelector('.navigation-main');
  navBar = (navBar && navBar.closest('nav, header, .shopify-section')) ||
           document.querySelector('header');
  if (navBar) navBar.addEventListener('mouseleave', closeMenu);
})();